<cam-layout-side class="full-width">
  <cam-layout-side-content>
    @let list = this.list$ | async;
    <div class="p-space-sm">
      <cam-loader [isLoading]="this.requestState.isLoading()">
        <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
          <cam-menu-navigation
            [menu]="this.menu"
            container="tab"
            [options]="{
              spaceElement: 'xs',
            }"
          ></cam-menu-navigation>
          <cam-empty [isEmpty]="!list || list.length === 0">
            <cam-list-container>
              @for (view of list; track view.id) {
                <cam-list-element (click)="this.selected(view)">
                  <cam-list-title>
                    <ng-template [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ view }"></ng-template>
                  </cam-list-title>
                  <cam-list-tag>
                    <ng-template [ngTemplateOutlet]="more" [ngTemplateOutletContext]="{ view }"></ng-template>
                  </cam-list-tag>
                </cam-list-element>
              }
            </cam-list-container>
          </cam-empty>
        </cam-error>
      </cam-loader>
    </div>
  </cam-layout-side-content>
  <cam-layout-side-cta>
    <cam-button icon="add" (action)="this.new()">
      {{ 'grid.viewsselection.new' | translate }}
    </cam-button>
  </cam-layout-side-cta>
</cam-layout-side>

<cam-layout-full-panel
  type="panel"
  [withSide]="true"
  [title]="this.formTitleKey()"
  [toggleState]="this.showForm !== 'view'"
  (closeEvent)="this.backToList()"
>
  <div panel-content class="p-space-sm">
    <cam-loader [isLoading]="this.requestState.isLoading()">
      <cam-form
        [inputs]="this.form"
        [canDisplayButton]="false"
        [askValidation$]="this.askValidation$"
        (valid)="this.save($event)"
      ></cam-form>
    </cam-loader>
  </div>
  <div panel-footer>
    <cam-button
      icon="check-line"
      [state]="this.requestState.isLoading() ? 'disabled' : 'classic'"
      (action)="this.validation()"
    >
      {{ 'grid.viewsselection.save' | translate }}
    </cam-button>
  </div>
</cam-layout-full-panel>

<ng-template #item let-view="view" [typedTemplate]="this.typeToken">
  <div class="item p-space-sm flex-column g-space-sm">
    <div class="name full-width">
      <cam-text size="lg" [isBold]="true" [color]="this.viewSelectedId === view.id ? 'brand-primary' : 'primary'">
        {{ view.name }}
      </cam-text>
    </div>
    <div class="flex-start align-center g-space-md">
      <div class="owner">
        <cam-user-logo [user]="view.owner" size="md" defaultType="trigram"></cam-user-logo>
      </div>
      <div class="type">
        <cam-text size="sm" color="brand-primary">
          {{ this.getTypeTranslationKey(view.type) | translate }}
        </cam-text>
      </div>
      <div class="date">
        <cam-text size="sm">
          {{ view.updatedTime ?? view.createdTime | date }}
        </cam-text>
      </div>
    </div>
    @if (view.sharedUsers && view.sharedUsers.length > 0) {
      <div class="flex-start align-center g-space-md shared">
        <cam-text size="sm" color="brand-primary">
          {{ 'grid.viewsselection.shared' | translate }}
        </cam-text>
        @for (user of view.sharedUsers; track user.id) {
          <cam-user-logo [user]="user" size="md" defaultType="trigram"></cam-user-logo>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #more let-view="view" [typedTemplate]="this.typeToken">
  <div class="more p-space-md" appStopPropagation>
    <cam-font-icon
      name="more"
      type="lg"
      [matMenuTriggerFor]="moreMenu"
      [matMenuTriggerData]="{ view: view }"
    ></cam-font-icon>
  </div>
</ng-template>

<mat-menu #moreMenu="matMenu" panelClass="views-more-menu">
  <ng-template matMenuContent let-view="view" [typedTemplate]="this.typeToken">
    <cam-menu [menu]="this.getMoreMenu(view)" container="panel"></cam-menu>
  </ng-template>
</mat-menu>

<ng-template #choicesTemplate let-item="item">
  <div class="flex-row align-center g-space-sm">
    <cam-user-logo [userInfo]="item" size="md" defaultType="trigram"></cam-user-logo>
    {{ item.firstName }} {{ item.lastName }}
  </div>
</ng-template>
